<template>
  <div id="StaticLayout">
    <header-vue :style="cor"></header-vue>
     <div class="content-center bg-gray">
      <router-view></router-view>
    </div>
    <footer-vue :style="cor"></footer-vue>
  </div>
</template>
<script>
  import HeaderVue from '@/components/layouts/HeaderVue'
  import FooterVue from '@/components/layouts/FooterVue'
 // import { mapState } from 'vuex'
  import dashboard from '@/services/dashboard'
 // import { cor } from '@/main'
  export default {
    name: 'StaticLayout',
    data () {
      return {
        cor: ''
      }
    },
    computed: {
      // ...mapState({
      //   cor: state => {
      //     const { cor } = state.cor
      //     return {
      //       'background-color': cor
      //     }
      //   }
      // })
    },
    components: {
      HeaderVue,
      FooterVue
    },
    created () {
      this.cor = {'background-color': `#${localStorage.getItem('corApp')}`}
    },
    methods: {
      sair: function () {
        localStorage.clear()
        this.$router.push('/login')
      }
    },
    mounted () {
      dashboard.listarDashboard().then(response => {
        // console.log(response)
      })
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/templates/StaticLayout.vue